// 台湾用语精确覆盖（简繁同形或需用台湾习惯的词条）
export const ZH_TW_OVERRIDES: Record<string, string> = {
  'common.refresh': '重新整理',
  'common.loading': '載入中',
  'common.noData': '暫無資料',
  'common.search': '搜尋',
  'common.save': '儲存',
  'common.open': '開啟',
  'common.pending': '處理中',
  'common.confirm': '確認',
  'common.cancel': '取消',
  'common.submit': '提交',
  'common.delete': '刪除',
  'common.edit': '編輯',
  'common.back': '返回',
  'common.all': '全部',
  'common.completed': '已完成',
  'common.failed': '失敗',
  'common.retry': '重試',
  'navigation.home': '首頁',
  'navigation.market': '行情',
  'navigation.trade': '交易',
  'navigation.portfolio': '投資組合',
  'navigation.mine': '我的',
  'navigation.wallet': '錢包',
  'home.totalAssets': '總資產',
  'home.available': '可用餘額',
  'home.trading': '交易',
  'home.marketData': '市場行情',
  'home.wallet': '錢包',
  'home.marketOverview': '市場概覽',
  'home.secure': '安全可靠',
  'home.highLiquidity': '高流動性',
  'trading.trade': '交易',
  'trading.spotTrading': '現貨交易',
  'trading.marginTrading': '現貨交易',
  'trading.secondsTrading': '秒合約',
  'trading.buy': '買入',
  'trading.sell': '賣出',
  'trading.long': '做多',
  'trading.short': '做空',
  'trading.market': '市價',
  'trading.limit': '限價',
  'trading.available': '可用',
  'trading.leverage': '槓桿',
  'trading.closePrice': '平倉價格',
  'trading.lots': '手數',
  'trading.margin': '保證金',
  'trading.frozen': '凍結',
  'trading.pending': '委託中',
  'trading.current': '目前委託',
  'trading.history': '已撤單',
  'trading.cancelled': '已撤單',
  'trading.holding': '持倉中',
  'trading.closePosition': '平倉',
  'trading.closePositionConfirm': '確認以當前市價平倉該持倉？',
  'trading.closePositionSuccess': '平倉成功',
  'trading.closePositionFailed': '平倉失敗',
  'trading.liquidatedOnClose': '已爆倉，保證金已全部損失',
  'trading.unrealizedProfit': '浮動盈虧',
  'trading.positionStatus': '持倉',
  'trading.openPositionLabel': '開倉',
  'trading.crossMargin': '全倉',
  'trading.positionQty': '持倉數量',
  'trading.execClosePrice': '成交價/平倉價格',
  'trading.tpSl': '止盈/止損',
  'trading.notSet': '--',
  'trading.statusLabel': '狀態',
  'trading.closed': '已平倉',
  'trading.liquidated': '已爆倉',
  'trading.noHolding': '暫無持倉',
  'trading.noClosedRecords': '暫無平倉紀錄',
  'trading.noCancelledRecords': '暫無撤單紀錄',
  'trading.openPrice': '開倉價',
  'trading.profit': '收益',
  'trading.crypto': '加密貨幣',
  'trading.volume24h': '24h 成交量',
  'trading.high24h': '24h 最高',
  'trading.low24h': '24h 最低',
  'market.market': '市場',
  'market.asset': '資產',
  'market.searchPlaceholder': '搜尋資產...',
  'market.loadFailed': '載入市場資料失敗',
  'profile.profile': '我的',
  'profile.walletManagement': '錢包管理',
  'profile.accountRecords': '帳戶紀錄',
  'profile.securityCenter': '安全中心',
  'profile.aboutUs': '關於我們',
  'profile.logout': '登出',
  'profile.deposit': '儲值',
  'home.quickDeposit': '存款',
  'home.financialNews': '財經要聞',
  'news.title': '財經新聞',
  'news.viewAll': '查看更多',
  'news.noNews': '暫無新聞',
  'news.source': '來源',
  'news.loadFailed': '載入新聞失敗',
  'news.categoryMarket': '市場',
  'news.categoryMacro': '宏觀',
  'news.categoryFutures': '期貨',
  'news.categoryCrypto': '加密',
  'deposit.title': '快捷儲值',
  'deposit.instructions': '請選擇幣種，向對應地址轉帳，然後填寫儲值金額並上傳轉帳成功截圖。',
  'deposit.network': '網路',
  'deposit.address': '收款地址',
  'deposit.copyAddress': '複製地址',
  'deposit.addressCopied': '地址已複製',
  'deposit.scanQr': '掃描 QR 碼轉帳',
  'deposit.amount': '儲值金額',
  'deposit.amountPlaceholder': '請輸入儲值金額',
  'deposit.minAmount': '最低儲值',
  'deposit.screenshot': '轉帳截圖',
  'deposit.uploadScreenshot': '上傳轉帳成功截圖',
  'deposit.uploadHint': '支援 JPG、PNG 格式，最大 10MB',
  'deposit.submit': '確認提交',
  'deposit.submitSuccess': '儲值申請已提交，請等待審核',
  'deposit.submitFailed': '提交失敗',
  'deposit.noAddress': '暫未設定收款地址，請聯絡客服',
  'deposit.pending': '審核中',
  'deposit.approved': '已通過',
  'deposit.rejected': '已駁回',
  'deposit.history': '儲值紀錄',
  'deposit.selectScreenshot': '請上傳轉帳截圖',
  'profile.withdraw': '提現',
  'profile.securityLevel': '安全等級',
  'profile.securityLevelHigh': '高',
  'profile.verified': '已認證',
  'profile.walletDesc': '查看資產、儲值、提現',
  'profile.recordsDesc': '儲值、提現、交易紀錄',
  'profile.securityDesc': '綁定電子郵件、修改密碼',
  'profile.aboutDesc': '版本資訊、客戶支援',
  'profile.logoutDesc': '安全登出您的帳戶',
  'profile.logoutConfirm': '確定要登出嗎？',
  'profile.confirmLogout': '確認登出',
  'profile.noActivity': '暫無活動紀錄',
  'security.emailBinding': '電子郵件綁定',
  'security.notBound': '未綁定',
  'security.loginPassword': '登入密碼',
  'security.changePassword': '修改密碼',
  'security.currentPassword': '目前密碼',
  'security.newPassword': '新密碼',
  'security.confirmNewPassword': '確認新密碼',
  'security.enterCurrentPassword': '請輸入目前密碼',
  'security.enterNewPassword': '請輸入新密碼',
  'security.enterConfirmPassword': '請確認新密碼',
  'security.passwordMismatch': '兩次輸入的密碼不一致',
  'security.passwordMinLength': '密碼長度至少 6 位',
  'security.passwordChanged': '密碼修改成功',
  'security.passwordChangeFailed': '密碼修改失敗',
  'about.contactUs': '聯絡我們',
  'about.noContent': '暫無內容',
  'records.withdrawApproved': '提現已通過審核',
  'records.withdrawRejected': '提現被駁回',
  'records.marginClose': '現貨交易平倉',
  'records.marginLiquidated': '現貨交易爆倉',
  'records.lostMargin': '損失保證金',
  'records.adminDeposit': '管理員上分',
  'auth.login': '登入',
  'auth.logout': '登出',
  'auth.email': '電子郵件',
  'auth.loginSuccess': '登入成功',
  'auth.loginFailed': '登入失敗',
  'auth.pleaseLogin': '請先登入',
  'auth.sessionExpired': '登入已逾時（30 分鐘無操作），請重新登入',
  'customerService.title': '客服',
  'customerService.online': '線上',
  'customerService.offline': '離線',
  'customerService.welcomeMessage': '您好，請問有什麼可以幫您？',
  'customerService.autoReply': '感謝您的諮詢，我們的客服人員會盡快為您處理。',
  'customerService.inputPlaceholder': '輸入您的問題…',
  'customerService.connecting': '連線中…',
  'customerService.sendMessage': '傳送',
  'customerService.sendHint': '按 Enter 傳送，Shift+Enter 換行',
  'kyc.title': '身分認證',
  'kyc.approved': '認證已通過',
  'kyc.approvedDesc': '您的身分認證已通過審核',
  'kyc.reviewing': '審核中',
  'kyc.reviewingDesc': '您的身分認證資料正在審核中，請耐心等待',
  'kyc.reviewingTime': '通常在 1-3 個工作日內完成審核',
  'kyc.rejected': '認證被拒絕',
  'kyc.rejectedReason': '拒絕原因',
  'kyc.resubmit': '請修改後重新提交',
  'kyc.realName': '真實姓名',
  'kyc.realNamePlaceholder': '請輸入真實姓名',
  'kyc.idNumber': '證件號碼',
  'kyc.idNumberPlaceholder': '請輸入身分證號碼',
  'kyc.idFront': '身分證正面',
  'kyc.idBack': '身分證反面',
  'kyc.uploadTip': '點擊上傳',
  'kyc.submitTip': '為了保障您的帳戶安全，請提交真實的身分資訊。審核通過後即可使用全部功能。',
  'kyc.refreshStatus': '重新整理狀態',
  'kyc.fillRequired': '請填寫真實姓名和證件號碼',
  'kyc.uploadRequired': '請上傳身分證正反面照片',
  'kyc.submitSuccess': '身分認證資料已提交，請等待管理員審核',
  'kyc.submitFailed': '提交失敗',
  'kyc.networkError': '網路錯誤，請稍後重試',
  'kyc.notVerified': '未認證，點擊提交認證資料',
  'kyc.clickToVerify': '點擊認證',
  'kyc.waitingReview': '審核中，請等待管理員審核',
  'kyc.rejectedClickResubmit': '認證被拒絕，點擊重新提交',
  'wallet.withdrawAmount': '提現金額',
  'wallet.withdrawAmountPlaceholder': '請輸入提現金額',
  'wallet.withdrawAddress': '提現地址',
  'wallet.withdrawAddressPlaceholder': '請輸入提現地址',
  'wallet.fee': '手續費',
  'wallet.actualAmount': '實際到帳',
  'wallet.withdrawing': '提現中',
  'chart.noData': '暫無圖表資料',
  'chart.highest': '最高',
  'chart.lowest': '最低',
  'chart.current': '目前',
  'chart.priceChart': '價格走勢',
  'chart.loadFailed': '載入圖表資料失敗',
  'chart.klineChart': 'K 線圖',
  'chart.dataPoints': '資料點',
  'chart.recentData': '最近資料',
  'chart.open': '開盤',
  'chart.close': '收盤',
  'chart.changeCol': '漲跌',
  'chart.retry': '重試',
  'chart.time': '時間',
  'chart.interval1m': '1 分鐘',
  'chart.interval5m': '5 分鐘',
  'chart.interval15m': '15 分鐘',
  'chart.interval1h': '1 小時',
  'chart.interval4h': '4 小時',
  'chart.interval1d': '1 天',
  'order.noOrders': '暫無訂單紀錄',
  'seconds.title': '秒合約',
  'seconds.bullish': '看漲',
  'seconds.bearish': '看跌',
  'seconds.profitRate': '報酬率',
  'seconds.countdown': '倒數計時',
  'seconds.currentPrice': '目前價格',
  'seconds.win': '獲利',
  'seconds.lose': '虧損',
  'seconds.inProgress': '進行中',
  'seconds.settled': '已結算',
  'register.title': '建立新帳戶',
  'register.emailTab': '電子郵件註冊',
  'register.accountTab': '帳號註冊',
  'register.sendCode': '發送驗證碼',
  'register.loginLink': '立即登入',
  'register.networkError': '網路錯誤，請稍後重試',
  'register.devModeHint': '開發模式：如果收不到郵件，請查看後端控制台取得驗證碼',
  'login.title': '登入您的帳戶',
  'login.loginButton': '登入',
  'login.loginSuccess': '登入成功！',
  'login.loginFailed': '登入失敗',
  'login.networkError': '網路錯誤，請稍後重試',
  'login.invalidCredentials': '電子郵件或密碼錯誤',
  'login.userNotFound': '用戶不存在',
  'login.signUpLink': '立即註冊',
  'login.noAccount': '還沒有帳號？',
  'priceAlert.pageTitle': '價格提醒',
  'priceAlert.createAlert': '建立提醒',
  'priceAlert.totalCount': '總提醒數',
  'priceAlert.activeCount': '活躍提醒',
  'priceAlert.triggeredCount': '已觸發',
  'priceAlert.recordsTotal': '共 {total} 筆紀錄',
  'priceAlert.smsNotify': '簡訊通知',
  'priceAlert.pushNotify': '推播通知',
}
